import { AntButton } from '@/common/ant-components/AntButton';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

export const Back = () => {
  const navigate = useNavigate();

  return (
    <AntButton
      style={{
        marginLeft: '15px',
        marginRight: '4px',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '5px',
      }}
      onClick={() => {
        navigate(-1);
      }}
    >
      Back
    </AntButton>
  );
};
